//  const baseUrl = "http://localhost:9089";
//  const golfUrl = "http://localhost:9085";

// // ログイン認証API
// export const golfLoginApi =`${baseUrl}/reserve/api/common/login`;

// // 詳細条件取得API
// export const detailConditionApi = `/reserve/api/golf/detailConditionItem`;

// // 施設情報取得API
// export const golfFacility = ` ${golfUrl}/reserve/api/golf/facilityInfo`;

// // 検索条件お気に入り取得API
// export const favoriteApi = ` ${golfUrl}/reserve/api/golf/getFavoriteConditions`;

// // 検索条件お気に入り登録API
// export const favoriteAddApi = ` ${golfUrl}/reserve/api/golf/setFavoriteConditions`;

// // 検索結果取得API
// export const searchResultApi = ` ${golfUrl}/reserve/api/golf/getGolfPlanList`;

// // 予約処理 追加＆コミットAPI
// export const reserveApi = ` ${golfUrl}/reserve/api/golf/reserveGolfPlanAddCommit`;

// // リクエスト予約
// export const requestReserveApi = ` ${golfUrl}/reserve/api/golf/requestGolfReservationPost`;

// // 2週間分の空き情報取得API
// export const vacancyOverviewApi = ` ${golfUrl}/reserve/api/golf/getVacancyOverview`;

// // お気に入り検索条件削除API
// export const deleteFavoriteConditionsApi = ` ${golfUrl}/reserve/api/golf/deleteFavoriteConditions`;

// // ver取得API
// export const versionGetApi = `/reserve/api/golf/golfVersion`;

// // ver取得API
// export const ssoLogin = `/reserve/api/common/ssoLogin`;

// // apiキーチェック
// export const apiKeyCheck = `/reserve/api/common/checkApiKeyAuth`;

//お知らせ取得(test)
export const getNewsListTest = `https://test.rtg.jp/wp-json/rtcc/v1/news/list/`;

//お知らせ詳細取得(test)
export const getNewsDetailListTest = `https://test.rtg.jp/wp-json/rtcc/v1/news/detail/`;

//トピックス取得(test)
export const getTopicsListTest = ` https://test.rtg.jp/wp-json/rtcc/v1/topics/list/`;

// //ホテル一覧取得
// export const getHotelList = `/rtcc/api/getHotelList`;

// // 予約確認一覧取得
// export const golfReservationList = ` ${golfUrl}/aaa`

// ログイン認証API
export const golfLoginApi = `/reserve/api/common/login`;

// ゲストログインAPI
export const guestLoginApi = `/reserve/api/common/guestLogin`;

// 詳細条件取得API
export const detailConditionApi = `/reserve/api/golf/detailConditionItem`;

// 施設情報取得API
export const golfFacility = `/reserve/api/golf/facilityInfoList`;

// 施設情報取得API
export const golfFacilitySearch = `/reserve/api/golf/facilityInfo`;

// 検索条件お気に入り取得API
export const favoriteApi = `/reserve/api/golf/getFavoriteConditions`;

// 検索条件お気に入り登録API
export const favoriteAddApi = `/reserve/api/golf/setFavoriteConditions`;

// 検索結果取得API
export const searchResultApi = `/reserve/api/golf/getGolfPlanList`;

// 予約処理 追加＆コミットAPI
export const reserveApi = `/reserve/api/golf/reserveGolfPlanAddCommit`;

// リクエスト予約
export const requestReserveApi = `/reserve/api/golf/requestGolfReservationPost`;

// 2週間分の空き情報取得API
export const vacancyOverviewApi = `/reserve/api/golf/getVacancyOverview`;

// お気に入り検索条件削除API
export const deleteFavoriteConditionsApi = `/reserve/api/golf/deleteFavoriteConditions`;

// ver取得API
export const versionGetApi = `/reserve/api/golf/golfVersion`;

// ver取得API
export const ssoLogin = `/reserve/api/common/ssoLogin`;

// apiキーチェック
export const apiKeyCheck = `/reserve/api/common/checkApiKeyAuth`;

//お知らせ取得
export const getNewsList = `https://www.rtg.jp/wp-json/rtcc/v1/news/list/`;

//お知らせ詳細取得
export const getNewsDetailList = `https://www.rtg.jp/wp-json/rtcc/v1/news/detail/`;

//トピックス取得
export const getTopicsList = ` https://www.rtg.jp/wp-json/rtcc/v1/topics/list/`;

//ホテル一覧取得
export const getHotelList = `/rtcc/api/getHotelList`;

// 予約確認一覧取得
export const golfReservationList = `/reserve/api/golf/reservationList`

// 予約変更
export const golfReservationChange = `/reserve/api/reserveGolfPlanChange`

// 予約キャンセル
export const golfReservationCancel = `/reserve/api/golf/requestGolfCancel`

// 会員権チェック
export const GolfMemberCheck = '/reserve/api/golf/getGolfMemberCheck'

// プラン詳細取得
export const GetGolfPlanDetail = '/reserve/api/golf/requestGolfDetail'

// 環境値取得
export const getEnvParam = `/reserve/api/common/getEnvParam`

// 同行者予約確認
export const golfReserveChk = `/reserve/api/golf/memberReservations`;

// ゴルフ1人予約
// 1人予約プラン検索
export const getSoloVacancyOverview = `/reserve/api/golf/getSoloVacancyOverview`;

// 1人予約空き状況取得
export const getSoloAvailability = `/reserve/api/golf/getSoloAvailability`;

// 1人予約新規予約
export const soloReserveGolfPlanAddCommit = `/reserve/api/golf/soloReserveGolfPlanAddCommit`;

// 1人予約予約キャンセル
export const soloGolfCancel = `/reserve/api/golf/soloGolfCancel`;

// 1人予約状況一覧取得
export const soloReservationList = `/reserve/api/golf/soloReservationList`;

// 1人予約状況詳細取得
export const soloReservationDetail = `/reserve/api/golf/soloReservationDetail`;


// 会員制ホテル
// 施設・部屋グレード情報取得
export const getFacilityInfo = `/reserve/api/resv/getFacilityInfo`;

// カレンダー検索用検索情報取得
export const getVacancyList = `/reserve/api/resv/getVacancyList`;

// カレンダー検索用レストラン空席状況取得
export const getRestaurantVacancyList = `/reserve/api/resv/getRestaurantVacancyList`;

// カレンダー検索用2か月分表示情報取得
export const getVacancy2Month = `/reserve/api/resv/getVacancy2Month`;

// プラン検索結果情報取得
export const getAvailablePlan = `/reserve/api/resv/getAvailablePlan`;

// 部屋タイプ情報取得
export const getRoomList = `/reserve/api/resv/getRoomList`;

// レストラン一覧取得
export const getRestaurantList = `/reserve/api/resv/getRestaurantList`;

// プランコース一覧取得
export const getCourseListFromPlan = `/reserve/api/resv/getCourseListFromPlan`;

// 同意内容取得
export const getAgreeInfo = `/reserve/api/resv/getAgreeInfo`;

// 食事コース一覧取得
export const getMealCourseList = `/reserve/api/resv/getMealCourseList`;

// 食事開始時間一覧取得
export const getMealStartTimeList = `/reserve/api/resv/getMealStartTimeList`;

// レストラン空き情報取得
export const getOpenRestaurantList = `/reserve/api/resv/getOpenRestaurantList`;

// シャトルバス時刻情報取得
export const getShuttleBusTimeList = `/reserve/api/resv/getShuttleBusTimeList`;

// 会員との関係一覧取得
export const getMemberRelationList = `/reserve/api/resv/getMemberRelationList`;

// サービスチェック取得
export const getServiceCheck = `/reserve/api/resv/getServiceCheck`;

// 都道府県一覧取得
export const getPrefectureList = `/reserve/api/resv/getPrefectureList`;

// 交通機関一覧取得
export const getTransportList = `/reserve/api/resv/getTransportList`;

// 権利消化選択情報取得
export const getRightDigestionSelectionInfo = `/reserve/api/resv/getRightDigestionSelectionInfo`;

// 予約プラン料金取得
export const planTotalPrice = `/reserve/api/resv/planTotalPrice`;

// 予約登録
export const setReserve = `/reserve/api/resv/setReserve`;

// 同行者取得
export const getDouhanList = `/reserve/api/resv/getDouhanList`;

// 予約一覧取得
export const getReserveList = `/reserve/api/resv/getReserveList`;

// 予約内容取得
export const getReserveInfo = `/reserve/api/resv/getReserveInfo`;

// 予約変更
export const changeReserve = `/reserve/api/resv/changeReserve`;

// 予約キャンセル
export const cancelReserve = `/reserve/api/resv/cancelReserve`;

// ログイン無し空室表示
export const vacancyPublic = '/reserve/api/resv/vacancyPublic';

// 保存検索条件取得
export const selectSaveSearchInfo = `/reserve/api/resv/selectSaveSearchInfo`;

// 保存検索条件登録・更新
export const registSaveSearchInfo = `/reserve/api/resv/registSaveSearchInfo`;

// 保存検索条件削除
export const deleteSaveSearchInfo = `/reserve/api/resv/deleteSaveSearchInfo`;

// 保存検索条件取得
export const selectSaveHomeFlInfo = `/reserve/api/resv/selectSaveHomeFlInfo`;

// 保存検索条件登録・更新
export const registSaveHomeFlInfo = `/reserve/api/resv/registSaveHomeFlInfo`;

// 保存検索条件削除
export const deleteSaveHomeFlInfo = `/reserve/api/resv/deleteSaveHomeFlInfo`;

// 同行者登録
export const registerCompanion = `/reserve/api/resv/registerCompanion`;

// プロパティ一覧取得
export const getPropertyList = `/reserve/api/resv/getTypePropertyList`;

// 権利自動割当取得
export const getKenriWariate = `/reserve/api/resv/getKenriWariate`;

// 権利自動割当取得
export const getRiyobiList = `/reserve/api/resv/getRiyobiList`;

// 郵便番号検索
export const searchZipCode = `/reserve/api/resv/searchZipCode`;

// TOP画面表示チェック
export const GetTopMenuList = `/reserve/api/common/menuList`;

// 施設・部屋グレード情報取得
export const CrawlLogin = `/reserve/api/common/crawlLogin`;

// 施設・グレード一覧取得
export const getShisetsuGradeList = `/reserve/api/resv/getShisetsuGradeList`

// 占有日一覧取得
export const getSenyuNenList = `/reserve/api/resv/getSenyuNenList`;

// レストラン・エステ
// レストラン選択情報取得
export const getRestaurantSelectionInfo = `/reserve/api/resv/getRestaurantSelectionInfo`;

// 予約可能時間取得
export const getYoyakuKanoTimeInfo = `/reserve/api/resv/getYoyakuKanoTimeInfo`;

// 外来カレンダー空き室取得
export const getVacancyCalendarRstEsthe = `/reserve/api/resv/getVacancyCalendarRstEsthe`;

// コース情報取得
export const getCourseInfo = `/reserve/api/resv/getCourseInfo`;

// 施設情報取得
export const getShisetsu = `/reserve/api/resv/getShisetsu`;

// エステ情報(施設CD)取得
export const getEsthetic = `/reserve/api/resv/getEsthetic`;

// エステ予約内容SMS送信																																			
export const sendSmsEstheticReservation = `/reserve/api/resv/sendSmsEstheticReservation`;

// 社員用検索画面会員権情報取得
export const getKaiinInfoCrawl = '/reserve/api/resv/getKaiinInfoCrawl';

// 同伴者選択リスト取得
export const getDouhanSelectList = '/reserve/api/resv/getDouhanSelectList';